import React from "react"
import getClientLogoBand from "./clientLogoBand"

/**
 * One client logo in its sized box — src/styles/clientLogos.scss. Used by
 * the homepage marquee and About Us (src/components/Clients.js) and every
 * industry Trusted By section, so a logo looks and behaves identically
 * wherever it appears.
 *
 * `client` is an entry from useClientLogos() ({ name, colorImage,
 * grayImage, size? }). Grey always — colour never shows here, anywhere:
 * grayImage first, and only when a client has no grey file yet does
 * colorImage stand in, CSS-grayscale-filtered so it still reads as grey
 * (clientLogos.scss's --filtered). No colour-on-hover swap. Renders
 * nothing if neither image resolved.
 */
const ClientLogoBox = ({ client }) => {
  const image = client.grayImage || client.colorImage
  if (!image) return null

  const filtered = !client.grayImage && !!client.colorImage
  const band = client.size || getClientLogoBand(image.width, image.height)

  return (
    <span
      className={`client-logo-box client-logo-box--${band}${filtered ? " client-logo-box--filtered" : ""}`}
    >
      <img
        src={image.fluid.srcWebp || image.fluid.src}
        srcSet={image.fluid.srcSetWebp || image.fluid.srcSet}
        sizes={image.fluid.sizes}
        alt={client.name}
        loading="lazy"
        decoding="async"
      />
    </span>
  )
}

export default ClientLogoBox
